var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBankCard = function SvgBankCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.33 14.667a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13c0-.543.264-1.021.667-1.325a1.647 1.647 0 0 0-1-.342 1.667 1.667 0 1 0 0 3.334c.361-.001.713-.121 1-.342A1.658 1.658 0 0 1 12 13Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F44336",
    strokeLinejoin: "round",
    d: "M6.516 7.611h10.973v8.779H6.516z"
  })));
};
export default SvgBankCard;